import type { StylableElementProps } from '@subaio/components'

import { getIsoCountryCode } from '../countryCodeMaps'
import { getCountryFlagImageUrl } from './getCountryFlagImageUrl'
import { Image } from './Image'

type Props = StylableElementProps & {
	countryCode: string | null
	size?: number
	defaultImage?: string
	isRounded?: boolean
}

export const CountryFlag = ({ countryCode, size = 28, defaultImage, isRounded = true, className, style }: Props) => {
	const imageUrl = getCountryFlagImageUrl(getIsoCountryCode(countryCode) ?? '') ?? defaultImage

	return imageUrl ? (
		<Image src={imageUrl} size={size} className={className} style={style} isRounded={isRounded} />
	) : null
}
